import React from 'react';
import { adjustments, photos } from '../data/content';
import { OfferLink } from './ui/OfferLink';
import { Eyebrow, Mark } from './ui/Section';
export function Coaches() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-41" data-mp="3ihorfv339l3q">
      <div className="mx-auto grid max-w-5xl items-center gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] lg:gap-12" data-id="element-42" data-mp="3ijjfvjdkjvck">
        <OfferLink className="mx-auto w-full max-w-sm" label="See the Complete Injury Rehabilitation Bundle offer" data-id="element-43" data-mp="3dpf50p16n367">
          <img src={photos.coachGuiding} alt="Coach guiding an adult through a resistance band shoulder exercise" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-xl transition-transform duration-300 ease-out group-hover:scale-[1.01]" data-id="element-44" data-mp="3nh1lp0wahugc" />
        </OfferLink>
        <div data-id="element-45" data-mp="2729w0vqj31aq">
          <Eyebrow align="left" data-id="element-46" data-mp="273upei13we70">Built for practical use</Eyebrow>
          <h2 className="font-display text-xl font-black uppercase leading-tight text-navy md:text-3xl" data-id="element-47" data-mp="223ow6xf6ujmt">
            Different people. Different levels. <Mark data-id="element-48" data-mp="2p5s37tpc4ihx">One organized system.</Mark>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-steel md:text-base" data-id="element-49" data-mp="2u3bt5qveajpp">
            Keep the same training goal and adapt:
          </p>
          <ul className="mt-3 flex flex-wrap gap-2" data-id="element-50" data-mp="2y4dk7kf5rpgl">
            {adjustments.map(item => <li key={item} className="rounded-md bg-brand px-3 py-1.5 text-[11px] font-black uppercase tracking-wide text-white" data-id="element-51" data-mp="32wosbak1yhk8">
                {item}
              </li>)}
          </ul>
          <p className="mt-5 font-display text-xs font-black uppercase tracking-wide text-brand md:text-sm" data-id="element-52" data-mp="3ht62vzkf3s5q">
            Designed for coaches, trainers and physically active adults.
          </p>
        </div>
      </div>
    </section>;
}